import ClockIcon from "../../../../../../../assets/svg/clock-icon";
import SortAscendingIcon from "../../../../../../../assets/svg/sort-ascending-icon";
import SortAZIcon from "../../../../../../../assets/svg/sort-az-icon";
import SortZAIcon from "../../../../../../../assets/svg/sort-za-icon";

import { StageSortOption } from "../utils/types";

const STAGE_SORT_OPTIONS = [
  {
    id: "latest_updated" as StageSortOption,
    label: "Latest Updated",
    icon: ClockIcon,
    className: "w-3.5 h-3.5",
  },
  {
    id: "new_created" as StageSortOption,
    label: "New Created",
    icon: SortAscendingIcon,
    className: "w-4 h-4",
  },
] as const;

const ALPHA_SORT_OPTIONS = [
  {
    id: "sort_az" as StageSortOption,
    label: "Sort A-Z",
    icon: SortAZIcon,
    className: "w-4 h-4",
  },
  {
    id: "sort_za" as StageSortOption,
    label: "Sort Z-A",
    icon: SortZAIcon,
    className: "w-4 h-4",
  },
] as const;

interface TicketStageSortingPopperProps {
  activeSort: StageSortOption | null;
  onSort: (sortOption: StageSortOption) => void;
  onReset: () => void;
  positionClassName?: string;
  isAlphaSort?: boolean;
}

export const TicketStageSortingPopper = ({
  activeSort,
  positionClassName = "top-full left-0",
  onSort,
  onReset,
  isAlphaSort = true,
}: TicketStageSortingPopperProps) => {
  const renderOption = (option: {
    id: StageSortOption;
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    className?: string;
  }) => {
    const Icon = option?.icon;
    const isActive = activeSort === option?.id;

    return (
      <div
        key={option.id}
        className={`flex items-center gap-1 px-2 py-2 cursor-pointer rounded-lg hover:bg-hover-effect dark:hover:bg-hover-effect-dk ${
          isActive ? "bg-card-highlight dark:bg-card-highlight-dk" : ""
        }`}
        onClick={() => onSort(option?.id)}
      >
        <Icon
          className={`shrink-0 text-verba-indigo dark:text-verba-indigo-dk ${option?.className}`}
        />
        <p className="text-md font-normal text-heading-text dark:text-heading-text-dk leading-normal">
          {option?.label}
        </p>
      </div>
    );
  };

  return (
    <div
      data-sort-dropdown
      className={`absolute p-3 flex flex-col gap-3 border border-border-gray dark:border-border-gray-dk bg-popper-bg-fixed-white dark:bg-popper-bg-fixed-white-dk rounded-lg shadow-popper-blur-effect backdrop-blur-[20px] w-[160px] z-50 ${positionClassName}`}
    >
      <div className="flex flex-col">
        {STAGE_SORT_OPTIONS?.map(renderOption)}
      </div>

      {isAlphaSort && (
        <>
          <hr className="border-border-gray dark:border-border-gray-dk" />
          <div className="flex flex-col">
            {ALPHA_SORT_OPTIONS?.map(renderOption)}
          </div>
        </>
      )}

      <button
        className="text-left text-md font-semibold w-max text-verba-blue dark:text-verba-blue-dk hover:underline cursor-pointer disabled:cursor-not-allowed! disabled:opacity-50 disabled:text-gray-placeholder dark:disabled:text-gray-placeholder-dk"
        onClick={onReset}
        disabled={!activeSort}
      >
        Reset
      </button>
    </div>
  );
};
